var React = require('react');

function JavascriptLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#f7df1e","d":"M0 0h630v630H0z","key":0}),React.createElement("path",{"fill":"#000000","d":"M423.2 492.2c12.7 20.72 29.2 35.95 58.4 35.95 24.53 0 40.2-12.26 40.2-29.2 0-20.3-16.1-27.5-43.1-39.3l-14.8-6.35c-42.72-18.2-71.1-41-71.1-89.2 0-44.4 33.83-78.2 86.7-78.2 37.64 0 64.7 13.1 84.2 47.4l-46.1 29.6c-10.15-18.2-21.1-25.37-38.1-25.37-17.34 0-28.33 11-28.33 25.37 0 17.76 11 24.95 36.4 35.95l14.8 6.34c50.3 21.57 78.7 43.56 78.7 93 0 53.3-41.87 82.5-98.1 82.5-54.98 0-90.5-26.2-107.88-60.54zm-209.13 5.13c9.3 16.5 17.76 30.45 38.1 30.45 19.45 0 31.72-7.6 31.72-37.2v-201.3h59.2v202.1c0 61.3-35.94 89.2-88.4 89.2-47.4 0-74.85-24.53-88.8-54.075z","key":1})]);
}

JavascriptLogo.defaultProps = {"viewBox":"0 0 630 630"};

module.exports = JavascriptLogo;

JavascriptLogo.default = JavascriptLogo;
